export default "__VITE_ASSET__3A0OtorE__"